export default __webpack_public_path__ + "static/media/crew-05.468546fb.svg";